import styled from 'styled-components';
import { neutral } from '../../../style/colors';

const Icon = styled.i`
  margin-left: auto;
  font-size: 20px;
  flex-shrink: 0;
  transition: color 0.2s ease;

  /* Default color */
  color: ${neutral[400]};

  /* PDF - Red */
  &.mdi-file-pdf-outline {
    color: #dc2626;
  }

  /* Word docs - Blue */
  &.mdi-file-word-box {
    color: #2563eb;
  }

  /* Excel - Green */
  &.mdi-file-excel-box {
    color: #16a34a;
  }

  /* Images - Purple */
  &.mdi-file-image-outline {
    color: #7c3aed;
  }

  /* Zip - Amber */
  &.mdi-zip-box {
    color: #d97706;
  }
`;

export default Icon;
